import { render } from "./VerticalMenu.vue?vue&type=template&id=257dd7a5"
import script from "./VerticalMenu.vue?vue&type=script&lang=js"
export * from "./VerticalMenu.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/VerticalMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "257dd7a5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('257dd7a5', __exports__)) {
    api.reload('257dd7a5', __exports__)
  }
  
  module.hot.accept("./VerticalMenu.vue?vue&type=template&id=257dd7a5", () => {
    api.rerender('257dd7a5', render)
  })

}


export default __exports__